// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4ad4fa2","239":"5990da9b","455":"ed10e387","557":"3200333d","762":"55de3fc7"}[chunkId] + ".chunk.js";
};